import {connect} from 'react-redux'

import {ModalContactRequestEmp} from './ModalContactRequestEmp'

export const ModalContactRequestEmpContainer = connect(
  null,
  null
)(ModalContactRequestEmp)
